module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "starRate-container"
  }, [_c('div', {
    staticClass: "starRate-title"
  }, [_vm._t("default", [_vm._v("Avaliação")])], 2), _vm._v(" "), _c('div', [_vm._l((5), function(n) {
    return [(n <= _vm.teste) ? [_c('v-icon', {
      key: n,
      staticClass: "starRate-stars"
    }, [_vm._v("star")])] : (1 > n - _vm.teste > 0) ? [_c('v-icon', {
      key: n,
      staticClass: "starRate-stars"
    }, [_vm._v("star_half")])] : [_c('v-icon', {
      key: n
    }, [_vm._v("star_border")])]]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0c6b16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StarRate.vue
// module id = 735
// module chunks = 3